<template>
	<div id="navbar-bm">
		<div class="topbar level is-mobile px-4 pt-2">
			<div class="navbar-title level-left">
				<i
					v-if="!isHome"
					class="fa fa-arrow-left pr-3"
					@click="onClickBack"
				></i>
				<h3 class="title is-4 is-txt-accent-dark">{{ name }}</h3>
			</div>
			<div class="navbar-item level-right">
				<div
					class="dropdown is-right px-2 level-item"
					:class="{ 'is-active': toggleMenuBtn }"
				>
					<div class="dropdown-trigger">
						<span
							class="icon is-small"
							aria-haspopup="true"
							aria-controls="dropdown-menu"
							@click="toggleMenuBtn = !toggleMenuBtn"
						>
							<i class="fas fa-bars is-txt-accent-dark" aria-hidden="true"></i>
						</span>
					</div>
					<div class="dropdown-menu" id="dropdown-menu" role="menu">
						<div class="dropdown-content">
							<!-- <hr class="dropdown-divider" /> -->
							<a href="#" class="dropdown-item" @click="signOut">
								Cerrar Sesión
							</a>
						</div>
					</div>
				</div>

				<span class="icon is-small px-2 level-item bell-icon" @click="onClickBell">
					<span class="pop-new" v-if="hasNewNotifications">&bull;</span>
					<i class="fa fa-bell is-txt-accent-dark"></i>
				</span>
			</div>
		</div>
		<notifications-view ref="nview"></notifications-view>
	</div>
</template>

<script lang="ts">
	import useAuth from "@/store/AuthState";
	import useNotification from "@/store/NotificationState";
	import { defineComponent, ref } from "vue";
	import { useRoute, useRouter } from "vue-router";
	import NotificationsView from "./NotificationsView.vue";

	const NavBar = defineComponent({
		name: "NavBar",
		components: { NotificationsView },
		props: {
			name: {
				type: String,
				required: true,
			},
		},
		setup() {
			const nview = ref(null);
			const router = useRouter();
			const route = useRoute();
			const isHome = ref<boolean>(route.name === "dashboard");
			const { hasNewNotifications } = useNotification();
			function onClickBack() {
				router.back();
			}
			function onClickBell() {
				(nview.value! as typeof NotificationsView).open();
			}
			let toggleMenuBtn = ref(false);
			const { signOut } = useAuth();
			return { nview, onClickBell, onClickBack, isHome, toggleMenuBtn, signOut, hasNewNotifications };
		},
		// type inference enabled
	});
	export default NavBar;
</script>

<style lang="stylus" scoped>
.bell-icon
	position relative
.pop-new
	display: inline-block
	position: absolute
	top: 0
	right: -4px
	color: red
	font-size: 27px
	line-height: 12px

</style>
